import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { CreateAccountModule } from './create-account/create-account.module';
import { PublicRoutingModule } from './public-routing.module';
import { PublicComponent } from './public.component';
import { PublicResolve } from './public.resolve';
import { VersionModule } from './version/version.module';
import { ConnectIntegrationsModule } from './connect-integrations/connect-integrations.module';
import { RedirectModule } from './oauth-redirect/redirect.module';
import { ConnectTradeDeskAgencyModule } from './connect-trade-desk-agency/connect-trade-desk-agency.module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { DemoDashboardComponent } from './demo-dashboard/demo-dashboard.component'
import {DemoDashboardModule} from "./demo-dashboard/demo-dashboard.module";

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        NgxMaskModule.forRoot(),
        SharedModule,
        CreateAccountModule,
        PublicRoutingModule,
        VersionModule,
        ConnectIntegrationsModule,
        RedirectModule,
        ConnectTradeDeskAgencyModule,
        DemoDashboardModule
    ],
    declarations: [PublicComponent],
    exports: [PublicComponent],
    providers: [PublicResolve]
})
export class PublicModule {}
